// Renders a small "$" marker on rows where the paid Google Places
// passes have already been run. Returns null otherwise - basic-tier
// rows aren't marked, so the column reads cleaner on a page where
// most rows are still on the default cheap pipeline.
// `premiumEnrichedAt` origin: `voa_rating_list_entry.premiumEnrichedAt`
// (exposed at the LeadCandidate level on /leads/search, mirrored onto
// Leads via `_sync_lead_data_from_voa` and surfaced on
// `tenantData.premiumEnrichedAt`).
export const EnrichmentTierBadge: React.FC<{
  premiumEnrichedAt: string | null | undefined;
}> = ({ premiumEnrichedAt }) => {
  if (premiumEnrichedAt == null) return null;
  return (
    <span
      style={{
        marginLeft: 4,
        color: "#198754",
        fontSize: 12,
        fontWeight: 700,
        cursor: "help",
      }}
      title={`Premium enrichment ran ${new Date(premiumEnrichedAt as string).toLocaleString()} - Google Places Text Search + Nearby on top of the default cheap pipeline.`}
      aria-label="Premium enriched"
    >
      $
    </span>
  );
};
